import React, { createContext, useState, useEffect } from 'react';
import {  get_user_infos } from './api';
import Keycloak from 'keycloak-js';
import { REDIRECT_URL, REALM, CLIENT, AUTH_URL } from './api';

const KeycloakContext = createContext();

const KeycloakProvider = ({ children }) => {

    const [userInfos, setUserInfos] = useState(null);
    const [keycloakLoading,setKeycloakLoading] = useState(true);
    const [keycloak, setKeycloak] = useState(null);
    const [authenticated, setAuthenticated] = useState(null);

    useEffect(() => {
        const keycloakInstance = new Keycloak({
            url: AUTH_URL,
            realm: REALM,
            clientId: CLIENT,
        });

        setTimeout(() => {
            setKeycloakLoading(true);
            keycloakInstance.init({
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
                checkLoginIframe: false,
            }).then(auth => {
                setKeycloak(keycloakInstance);
                setAuthenticated(auth);
                setKeycloakLoading(false);
            }).catch(err => {
                console.error('Keycloak init failed', err);
                setKeycloak(keycloakInstance);
                setAuthenticated(false);
                setKeycloakLoading(false);
            });
        }, 300); // test avec un petit délai
    }, []);

    const login = async () => {
        if (keycloak) {
            await keycloak.login({ redirectUri: REDIRECT_URL });
        }
    };

    const logout = async () => {
        if (keycloak) {
            await keycloak.logout({ redirectUri: REDIRECT_URL });
            setUserInfos(null);
        }
    };
    
    useEffect(() => {
        const fetchUserInfos = async () => {
            if (keycloak && keycloak.token) {
                try {
                    await getUserInfos();
                } catch (error) {
                    console.error(error);
                }
            }
        };
        fetchUserInfos();
    }, [keycloak, keycloak?.token]);

    const getUserInfos = async () => {
        const infos = await get_user_infos(keycloak.token);
        setUserInfos(infos);
    }

    return (
            <KeycloakContext.Provider value={{
                keycloak,
                userInfos,
                login,
                logout,
                authenticated,
                userInfos,
                keycloakLoading
            }}>
                {children}
            </KeycloakContext.Provider>
    );
};

export { KeycloakContext, KeycloakProvider };
